export const isSafeHTML = (html: string): boolean => {
    const test = /<script|on\w+=/i.test(html);
 
  if (test) {
    throw new Error('Unsafe HTML detected!');
  }

  return !test;
};
